import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { BatchJobStatusSearchParams } from './batch-job-status-search-params.model';
import { BatchJobStatus } from './batch-job-status.model';

@Injectable({
  providedIn: 'root',
})
export class BatchJobStatusDatasource extends TableDatasource<
  BatchJobStatus,
  BatchJobStatusSearchParams
> {
  endpoint = '/api/admin/batchjobstatus';
  defaultSortField = 'statusTidspunkt';
  override defaultDescending = true;
  override defaultTake = 1000;
}
